import { useQuery, UseQueryOptions } from "react-query"
import { getContent } from "../api/content"
import { PUBLIC_PAGE_API_ENDPOINT } from "../constants"
import { PageBaseProps } from "../components/Core/pageBase"

export const usePageQuery = (
	path: string,
	opts?: Omit<
		UseQueryOptions<any, unknown, any, string[]>,
		"queryKey" | "queryFn"
	>
) => {
	return useQuery<PageBaseProps, Error, PageBaseProps, string[]>(
		[path],
		() =>
			getContent(
				`${PUBLIC_PAGE_API_ENDPOINT}${path}${
					path.indexOf("?") < 0 ? "?page" : "&page"
				}`
			),
		{
			...opts,
		}
	)
}
